import { useState } from "react";

function useTimer(timeParam = 0) {
  const time = timeParam;
  const [timer, setTimer] = useState(null);

  const runTimer = (fn, params) => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    setTimer(
      setTimeout(() => {
        fn(...params);
      }, time)
    );
  };

  return [runTimer];
}

export { useTimer };

export const formatTime = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};